// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tomato {\r\n  background: rgb(255,99,71);\n}\n.error-text{\r\n  color: red;\n}\n.error-text:first-child {\r\n  margin: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
